import Select from './Select.vue';
import utile from '../../utile';

export default {
  getComponentByConfig(config) {
    return utile.resetComponentByConfig(config, 'select', Select);
  },
};
